// extracted by mini-css-extract-plugin
export default {"root":"AddressSelector_root__ZIF2a","select":"AddressSelector_select__7eE0A"};